// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--2ypfa","kicker":"index-module--kicker--1yncA"};